import createLucideIcon from '../createLucideIcon';

/**
 * @component @name Church
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTggNyA0IDJ2MTFhMiAyIDAgMCAxLTIgMkg0YTIgMiAwIDAgMS0yLTJWOWw0LTIiIC8+CiAgPHBhdGggZD0iTTE0IDIydi00YTIgMiAwIDAgMC0yLTJhMiAyIDAgMCAwLTIgMnY0IiAvPgogIDxwYXRoIGQ9Ik0xOCAyMlY1bC02LTMtNiAzdjE3IiAvPgogIDxwYXRoIGQ9Ik0xMiA3djUiIC8+CiAgPHBhdGggZD0iTTEwIDloNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/church
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Church = createLucideIcon('Church', [
  ['path', { d: 'm18 7 4 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9l4-2', key: 'gy5gyo' }],
  ['path', { d: 'M14 22v-4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v4', key: 'tdb53m' }],
  ['path', { d: 'M18 22V5l-6-3-6 3v17', key: '1hsnhq' }],
  ['path', { d: 'M12 7v5', key: 'ma6bk' }],
  ['path', { d: 'M10 9h4', key: 'u4k05v' }],
]);

export default Church;
